import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { investmentPlans } from "../../data";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import ready from "../../assets/ready.jpg";
import investnow from "../../assets/investnow1.jpg";

export default function InvestmentPlan() {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className="    w-[90%]  lg:w-[65%]   lg:my-[2rem]    mx-auto   flex   flex-col   gap-[1rem]">
      <div className="  lg:w-[50%]   w-full flex flex-col text-center  gap-5  justify-center  items-center  p-4  ">
        <motion.h5
          animate={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1.5 }}
          viewport={{ once: true }}
          className="text-[1.1rem]  text-black    capitalize text-center  mx-auto font-bold   tracking-wider p-[0.3rem] "
        >
          Select trading bots aligned with your investment style and objectives.
        </motion.h5>
      </div>
      <div className="w-full  grid grid-cols-1  gap-[1rem]  lg:grid-cols-2    ">
        <img src={investnow} alt="experts" className="" />
        <div>
          {investmentPlans.map((data) => (
            <Accordion
              expanded={expanded === `panel${data.id}`}
              onChange={handleChange(`panel${data.id}`)}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "black" }} />}
                aria-controls={`panel${data.id}bh-content`}
                id={`panel${data.id}bh-header`}
                sx={{ bgcolor: "white", color: "black" }}
              >
                <Typography
                  component="span"
                  sx={{
                    width: "80%",
                    flexShrink: 0,
                    fontWeight: "bold",
                  }}
                >
                  {data.icon}
                  {data.name}
                  {/* <span className="ml-[1rem]">{`( ${data.botName})`}</span> */}
                </Typography>
                {/* <Typography component="span" sx={{ color: "text.secondary" }}>
							ROI: <span>%{data.ROI}</span>
						</Typography> */}
              </AccordionSummary>
              <AccordionDetails sx={{ bgcolor: "black", color: "white" }}>
                <ul className="bg-white   list-inside  list-disc  text-black  capitalize">
                  <li className="    p-[0.5rem]  ">
                    <span className="font-serif  mx-[0.5rem]">
                      {" "}
                      Capital back:
                    </span>{" "}
                    <span>{data.CB}</span>
                  </li>
                  <li className="    p-[0.5rem]  ">
                    <span className="font-serif  mx-[0.5rem]">
                      {" "}
                      Withdrawal:
                    </span>{" "}
                    <span>Anytime</span>
                  </li>
                  <li className="    p-[0.5rem]">
                    <span className="font-serif  mx-[0.5rem]">
                      Daily profit:{" "}
                    </span>
                    <span>{data.ROI}%</span>
                  </li>
                  <li className="p-[0.5rem]">
                    <span className="font-serif  mx-[0.5rem]">
                      Referal commission:
                    </span>{" "}
                    <span>{data.RC}</span>
                  </li>
                  <li className="    p-[0.5rem]">
                    <span className="font-serif  mx-[0.5rem]">
                      {" "}
                      Minimum amount:{" "}
                    </span>
                    <span>${data.minAmount}</span>
                  </li>

                  <li className="    p-[0.5rem]">
                    <span className="font-serif  mx-[0.5rem]">
                      Maximum amount:
                    </span>{" "}
                    <span>
                      {data?.id === 7 ? "Unlimited" : "$" + data.maxAmount}
                    </span>
                  </li>
                  {/* <li className="bg-black"></li> */}
                </ul>
                <Link
                  className="bg-green-700     inline-block text-white   rounded-lg  my-[1rem]   py-3 px-5  font-medium  ml-[0.8rem]     text-[1.1rem]   font-serif    "
                  to="/en/register"
                >
                  Sign up to select your plan
                </Link>

                {/* <Link
								to="en/register"
								className="bg-blue-600 hover:bg-blue-700 text-white  border-2 border-red-500 font-semibold py-3 px-6 rounded-lg transition duration-300">
								Register to Buy Now
							</Link> */}
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </div>
    </div>
  );
}
